import z from 'zod'

const messageMinLength = 1
const messageMaxLength = 500

export const FakeNoteSchema = z.object({
    text: z.string().min(messageMinLength).max(messageMaxLength),
    // Transform empty strings to undefined for optional date field
    createdAt: z.date().optional(),
    // Transform empty strings to undefined for optional duration field
    duration: z.string().optional(),
})

export type FakeNoteFormData = z.infer<typeof FakeNoteSchema>
